import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ButtonFile, Modal } from '../../../components';
import { acceptOnlyImages } from '../../../components/ButtonFile';
import LoadingComponent from '../../../components/Loading';
import { SU } from '../../../constants/ConfigConst';
import * as CONST from '../../../constants/FieldsConst';
import { HOUR_BLOCK } from '../../../constants/enumsConst';
import { dateformat, getDateFormated, getDateTimezone } from '../../../helpers';
import { validFielddHelper } from '../../../helpers/ValidFieldsHelper';
import { useNotification } from '../../../helpers/notification';
import BotonNuevoComponent from '../../entidades/components/BotonNuevo';
import {
  checkModuleActionAccess,
  isManagerUserCode,
} from '../../modulos/modules.helpers';
import { saveSubAreasAction, setActivoSubAreasAction } from '../SubAreasAction';
import { Add } from '@mui/icons-material';
import FormSubareaSchedule from './FormSubareaSchedule';
import { FechaField } from '../../usuarios/components/FieldsUsuarios';
import { deleteChangeSubAreasService, saveChangeSubAreasService } from '../SubAreasService';
import { MORADO_COLOR } from '../../../constants/ColorsConst';
import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';
import useFetch from 'http-react';
import QRCode from 'react-qr-code';

export function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export function a11yProps(index) {
  return {
    id: `subarea-tab-${index}`,
    'aria-controls': `subarea-tabpanel-${index}`,
  };
}

const FormSubAreas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { addNotification } = useNotification();

  const areasStore = Redux.useSelector((state) => state.areas);
  const subareasStore = Redux.useSelector((state) => state.subareas);
  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const [openModalChangeShow, setOpenModalChangeShow] = React.useState(null);

  const [openModalChange, setOpenModalChange] = React.useState(false);
  const [existData, setExistData] = React.useState([]);
  const [modalConfirm, setModalConfirm] = React.useState(false);
  const [confirmDelete, setConfirmDelete] = React.useState(false);

  const isRoot = loginStore.user.roles.some((r) => r.name === SU);
  const isManager =
    !isRoot &&
    isManagerUserCode(loginStore.user.userCodes, entidadesStore.activo?.id);

  const [fileImage, setFileImage] = React.useState();
  const isHourBlock = areasStore.activo.blockReservation === HOUR_BLOCK;
  const timezone = entidadesStore.activo.country.timezone;
  // const interval = isHourBlock ? 30 : 1440;
  // const minutesUse = isHourBlock ? 30 : 1440;

  // const defaultDates = [
  //   {
  //     day: 0,
  //     startTime: areasStore.activo.openingTime || '00:00:00',
  //     endTime: areasStore.activo.closingTime || '23:59:59',
  //   },
  // ]


  const entityUserTypes = areasStore.activo?.entityUserTypes?.map?.((item) => ({
    id: item.id,
    name: item.name || item.userType?.name
  })) || [];

  const defaultDates = Array.from({ length: 7 }, (_, i) => {
    return {
      day: i,
      startTime: areasStore.activo.openingTime || '00:00:00',
      endTime: areasStore.activo.closingTime || '23:59:59',
    };
  });

  const defaultSchedules = Array.from({ length: 7 }, (_, i) => {
    return {
      day: i,
      blocks: [{
        start: areasStore.activo.openingTime || '00:00:00',
        end: areasStore.activo.closingTime || '23:59:59',
        interval: 30,
        minutesUse: 30,
        price: 0,
      }],
    };
  });

  const action = {
    read: checkModuleActionAccess('subareas', 'read', loginStore),
    create: checkModuleActionAccess('subareas', 'create', loginStore),
    delete: checkModuleActionAccess('subareas', 'delete', loginStore),
    update: checkModuleActionAccess('subareas', 'update', loginStore),
  };

  const [subarea, setSubArea] = React.useState({
    [CONST.NAME]: '',
    [CONST.OPENING_TIME]: areasStore.activo.openingTime,
    [CONST.CLOSING_TIME]: areasStore.activo.closingTime,
    [CONST.MAX_PERSONS]: 1,
    [CONST.MIN_PERSONS]: 1,
    // [CONST.INTERVAL]: interval,
    // [CONST.MINUTES_USE]: minutesUse,
    [CONST.MAX_PERSONS_SHARED]: 1,
    [CONST.PRICE]: 0,
    [CONST.ACTIVE]: true,
    [CONST.DAYS_FOR_RESERVE]: 7,
    [CONST.HOURS_FOR_RESERVE]: '00:00',
    [CONST.MIN_PREV_FOR_RESERVE]: 60,
    [CONST.ACTIVE]: true,
    isAttendantRequired: false,
    areAllTimesEqual: true,
    dates: defaultDates,
    participantType: 'total_only',
    minutesBeforeRemove: 60,
    schedules: defaultSchedules,
    accessDoorId: null,
    entityUserTypeIds: areasStore.activo?.entityUserTypes?.map?.((item) => item.id) || [],
  });
  const [dataError, setDataRequired] = React.useState({
    [CONST.NAME]: false,
  });

  const [loadingSave, setLoadingSave] = React.useState(false);
  const [tabs, setTabs] = React.useState(0);

  
  const [changeData, setChangeData] = React.useState({
    date: dayjs().add(subarea.daysForReserve, 'day').toDate(),
    schedules: [],
  });

  const onTabs = (event, newValue) => {
    setTabs(newValue);
  };

  const handleSaveChange = async () => {
    setExistData([]);
    try {
      // console.log('object');
      const a = {
        ...changeData,
        schedules: getScheduleChanges(changeData.schedules)
      }
      // console.log(a);
      const res = await saveChangeSubAreasService({
        ...changeData,
        schedules: getScheduleChanges(changeData.schedules),
        date: getDateTimezone(dayjs(changeData.date).startOf('day').format('YYYY-MM-DD HH:mm:ss'), timezone)
      })
      setOpenModalChange(false)
      addNotification('Cambio programado correctamente')
      const activo = {...subareasStore.activo}
      // console.log(res.data);
      activo.scheduleChanges.push(res.data)
      setActivoSubAreasAction(dispatch, activo)

    } catch (error) {
      console.log(error)
      addNotification('Error al programar el cambio', { error: true })
    }
  }

  const handleDeleteChange = async () => {
    const res = await deleteChangeSubAreasService(openModalChangeShow.id)
    setOpenModalChangeShow(null)
    addNotification('Cambio eliminado correctamente')
    const activo = {...subareasStore.activo}
    activo.scheduleChanges = activo.scheduleChanges.filter(change => change.id !== openModalChangeShow.id)
    setActivoSubAreasAction(dispatch, activo)
  }

  const { data: accessDoorsData, loading: loadingAccessDoors, reFetch } = useFetch(
    `${baseApi}/access-doors/short`,
    {
      id: `access-doors-app-is-areas-${entidadesStore.activo.id}`,
      headers: token({}),
      query: {
        isArea: true,
        withAreas: true,
      },
    }
  );
  const accessDoors = accessDoorsData || [];


  const handleLoadExistData = async () => {
    const valid = _validDataForm();
    if (!valid) return;
    const data = await axios.get(`${baseApi}/reservations/check-future-blocks`, {
      params: {
        subareaId: changeData.subareaId,
        date: openModalChangeShow.date
      },
      headers: await token({})
    })

    const existData = data.data.map((r) => {
      const isReservation = r.type === 'reservation';
      const data = {
        id: r.id,
        title: r.description,
        date: getDateFormated(r.entryTime, 'DD-MM-YYYY', timezone),
        start: getDateFormated(r.entryTime, 'hh:mm A', timezone),
        end: getDateFormated(r.departureTime, 'hh:mm A', timezone),
        type: r.type === 'block' && !!r.event ? 'Evento' : r.type === 'block' ? 'Bloqueo' : 'Reservación',
        subarea: `${r.subarea.name} - ${r.subarea.area.name}`,
        dateFrom: r.entryTime,
      }

      if (isReservation) {
        data.name = r.userCode ? `${r.userCode.user.profile.firstName} ${r.userCode.user.profile.lastName}` : null;
        data.code = r.userCode.code.code;
        data.avatar = r.userCode.avatar || r.userCode.user.profile.avatar;
      } else {
        data.title = r.description;
      }

      return data;
    }).sort((a, b) => new Date(a.dateFrom).getTime() - new Date(b.dateFrom).getTime());

    if (existData.length) {
      setModalConfirm(true);
      setExistData(existData);
    } else {
      handleDeleteChange();
    }
  }

  React.useEffect(() => {
    if (subareasStore.activo === null) return;
    let data = {};
    Object.keys(subarea).map((key) => (data[key] = subareasStore.activo[key]));
    data = {
      ...data,
      [CONST.OPENING_TIME]:
        subareasStore?.activo.openingTime || areasStore.activo.openingTime,
      [CONST.CLOSING_TIME]:
        subareasStore?.activo.closingTime || areasStore.activo.closingTime,
      // interval: isHourBlock ? subareasStore.activo.interval : 1440,
      // minutesUse: isHourBlock ? subareasStore.activo.minutesUse : 1440,
      areAllTimesEqual: subareasStore.activo.areAllTimesEqual,
      dates: subareasStore.activo.dates,
      schedules: subareasStore.activo.schedules,
      accessDoorId: subareasStore.activo.accessDoor?.id,
      entityUserTypeIds: subareasStore.activo.entityUserTypes?.map?.((item) => item.id) || [],
    };
    setSubArea(data);

    setChangeData({
      subareaId: subareasStore.activo.id,
      date: dayjs().add(subareasStore.activo.daysForReserve, 'day').startOf('day').toDate(),
      schedules: subareasStore.activo.schedules,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subareasStore.activo]);

  const _handleSetDataFieldArea = (key, value) =>
    setSubArea({ ...subarea, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = subarea[key];
      const valid = val === null || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const handleSubmit = async () => {
    setExistData([]);
    const valid = _validDataForm();
    if (areasStore.activo === null) return alert('Falta elegir un área');
    if (valid) {
      const data = {
        ...subarea,
        [CONST.AREA_ID]: areasStore.activo.id,
        [CONST.OPENING_TIME]: subarea.openingTime,
        [CONST.CLOSING_TIME]: dateformat(subarea.closingTime, {
          complete: true,
          isHHmmss: true,
        }),
        [CONST.HOURS_FOR_RESERVE]: dateformat(subarea.hoursForReserve, {
          complete: true,
          isHHmmss: true,
        }),
      };
      if (fileImage) data[CONST.IMAGE] = fileImage;
      setLoadingSave(true);
      let res = await saveSubAreasAction(
        { dispatch, addNotification },
        subareasStore.activo ? subareasStore.activo.id : null,
        data,
        subareasStore.params
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  const infoForm = (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <ButtonFile
              id={CONST.IMG_FOTO}
              onFile={(file) => setFileImage(file)}
              file={fileImage}
              text="Subir imagén del sub área"
              readOnly={isManager}
              sxc={{ marginTop: '5px' }}
              size="40%"
              name={subareasStore.activo ? subareasStore.activo.name : null}
              onDelete={() => setFileImage(null)}
              accept={acceptOnlyImages}
              src={
                fileImage
                  ? null
                  : subareasStore.activo
                  ? subareasStore.activo.imageUrl
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <TextField
                  fullWidth
                  size="small"
                  id={CONST.NAME}
                  required
                  label="Nombre"
                  inputProps={{ readOnly: isManager }}
                  value={subarea.name}
                  onChange={(e) =>
                    _handleSetDataFieldArea(CONST.NAME, e.target.value)
                  }
                  helperText={dataError.name ? validFielddHelper(1) : null}
                  error={dataError.name}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <FormControl fullWidth>
                  <InputLabel id="select-estatus-label">Estatus</InputLabel>
                  <Select
                    labelId="select-estatus-label"
                    size="small"
                    readOnly={isManager}
                    value={subarea.active}
                    label="Estatus"
                    onChange={(e) =>
                      _handleSetDataFieldArea(CONST.ACTIVE, e.target.value)
                    }
                    id={CONST.ACTIVE}
                  >
                    <MenuItem value={true}>Activo</MenuItem>
                    <MenuItem value={false}>Bloqueado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              
              {subareasStore?.activo?.qrCode && (<QRCode value={subareasStore.activo.qrCode.id.toString()} style={{ width: '50%' }} />)}
              
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );



  const getScheduleChanges = (schedules = []) => {
    return schedules.map(({ id, blocks, ...s }) => ({
      ...s,
      blocks: blocks.map(({ id, ...b }) => b)
    }))
  }

  const tablaDias = (
    <div>
      <FormSubareaSchedule
        edit={!subareasStore.activo}
        onChange={(res) => {
          const schedules = res.map(r => ({
            ...r,
            blocks: r.blocks.sort((a, b) => a.start.localeCompare(b.start))
          }))
          setSubArea({ ...subarea, schedules })
        }}
        data={subarea?.schedules ? getScheduleChanges(subarea.schedules) : undefined}
        allDay={!isHourBlock}
      />
      {subareasStore.activo && subareasStore.activo.scheduleChanges?.map(change => (
        <Grid item md={12} align="center" sx={{ m: 2 }}>
          <Typography variant="body">
            Se ha programado un cambio de horario para el día {dayjs(change.date).format('DD-MM-YYYY')}
          </Typography>
          <Button onClick={() => { setOpenModalChangeShow(change); }}>
            Ver horario
          </Button>
        </Grid>
      ))}
      {subareasStore.activo && subareasStore.activo.scheduleChanges?.length === 0 && (
        <Grid item md={12} align="center" sx={{ m: 2 }}>
          <Button onClick={() => { setOpenModalChange(true); }}>
            Programar cambio
          </Button>
        </Grid>
      )}
    </div>
  );

  const horariosForm = (
    <Grid container spacing={1}>
      {/* <Grid item xs={12} md={12}>
        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                checked={subarea.areAllTimesEqual}
                onChange={(e) => {
                  let dates = [...subarea.dates];
                  if (e.target.checked) {
                    dates = dates.map((d) => {
                      return {
                        ...d,
                        startTime: subarea.openingTime,
                        endTime: subarea.closingTime,
                      };
                    });
                  }
                  setSubArea({
                    ...subarea,
                    areAllTimesEqual: e.target.checked,
                    dates,
                  });
                }}
              />
            }
            label="Aplicar las mismas horas horas a todos los días de la semana"
          />
        </FormControl>
      </Grid> */}
      {/* {isHourBlock && subarea.areAllTimesEqual && (
        <Grid item xs={12} md={6}>
          <FormControl variant="standard" sx={{ width: '100%' }}>
            <Typography variant="body">Hora de apertura</Typography>
            <TextField
              size="small"
              type="time"
              inputProps={{ readOnly: isManager, min: '12:00', max: '20:00' }}
              value={subarea.openingTime}
              onChange={(e) => {
                const dates = [...subarea.dates];
                const value = `${e.target.value}:00`;
                setSubArea({
                  ...subarea,
                  openingTime: value,
                  dates: dates.map((d) => ({ ...d, startTime: value })),
                });
              }}
              id={CONST.OPENING_TIME}
            />
          </FormControl>
        </Grid>
      )}
      {isHourBlock && subarea.areAllTimesEqual && (
        <Grid item xs={12} md={6}>
          <FormControl variant="standard" sx={{ width: '100%' }}>
            <Typography variant="body">Hora de cierre</Typography>
            <TextField
              size="small"
              type="time"
              inputProps={{ readOnly: isManager }}
              value={subarea.closingTime}
              onChange={(e) => {
                const dates = [...subarea.dates];
                const value = `${e.target.value}:00`;
                setSubArea({
                  ...subarea,
                  closingTime: value,
                  dates: dates.map((d) => ({ ...d, endTime: value })),
                });
              }}
              id={CONST.CLOSING_TIME}
            />
          </FormControl>
        </Grid>
      )} */}

      <Grid item xs={12} md={12}>
        {tablaDias}
      </Grid>

      {/* <pre style={{ position: 'fixed', top: '0', left: '0', zIndex: '1000', background: 'white' }}>
        {JSON.stringify( subarea, null, 2)}
      </pre> */}
    </Grid>
  );

  const validacionesForm = (
    <Grid container spacing={1}>
      {/* {isHourBlock && (
        <Grid item xs={12} md={8}>
          <Typography variant="body">
            Intervalo de bloques <br />
            <br />
          </Typography>
        </Grid>
      )}
      {isHourBlock && (
        <Grid item xs={12} md={4}>
          <TextField
            size="small"
            type="number"
            value={subarea.interval}
            onChange={(e) =>
              _handleSetDataFieldArea(CONST.INTERVAL, e.target.value)
            }
            id={CONST.INTERVAL}
            InputProps={{
              inputProps: { min: 1, readOnly: isManager },
            }}
          />
        </Grid>
      )}
      {isHourBlock && (
        <Grid item xs={12} md={8}>
          <Typography variant="body">Minutos de uso</Typography>
        </Grid>
      )}
      {isHourBlock && (
        <Grid item xs={12} md={4}>
          <TextField
            size="small"
            type="number"
            value={subarea.minutesUse}
            onChange={(e) =>
              _handleSetDataFieldArea(CONST.MINUTES_USE, e.target.value)
            }
            id={CONST.MINUTES_USE}
            InputProps={{
              inputProps: { min: 0, readOnly: isManager },
            }}
          />
        </Grid>
      )} */}
      <Grid item xs={12} md={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={8}>
            <Typography variant="body">
              Usuarios permitidos
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Select
              labelId={'entityUserTypeIds'}
              id={'entityUserTypeIds'}
              size="small"
              value={subarea.entityUserTypeIds}
              placeholder="Selecciona un usuario permitido"
              fullWidth
              multiple
              onChange={(e) => {
                _handleSetDataFieldArea('entityUserTypeIds', e.target.value)
              }}
            >
              {entityUserTypes.map((eut) => {
                return (
                  <MenuItem key={eut.id} value={eut.id}>
                    {eut.name}
                  </MenuItem>
                );
              })}

            </Select>
          </Grid>
        </Grid>
      </Grid>
      {accessDoors.length > 0 && (
        <Grid item xs={12} md={12}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={8}>
              <Typography variant="body">
                Puerta de acceso
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Select
                labelId={'accessDoorId'}
                id={'accessDoorId'}
                size="small"
                value={subarea.accessDoorId}
                placeholder="Selecciona una puerta de acceso"
                fullWidth
                onChange={(e) => {
                  _handleSetDataFieldArea('accessDoorId', e.target.value)
                }}
              >
                {accessDoors.map((ad) => {
                  return (
                    <MenuItem key={ad.id} value={ad.id} disabled={!!(ad.area || ad.subarea) && subareasStore.activo?.accessDoor?.id !== ad.id}>
                      {ad.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} md={8}>
        <Typography variant="body">Cantidad de personas compartida</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.maxPersonsShared}
          onChange={(e) =>
            _handleSetDataFieldArea(CONST.MAX_PERSONS_SHARED, e.target.value)
          }
          id={CONST.MAX_PERSONS_SHARED}
          InputProps={{
            inputProps: { min: 0, readOnly: isManager },
          }}
        />
      </Grid>
      
      
      {/* {!isHourBlock && (
        <>
          <Grid item xs={12} md={8}>
            <Typography variant="body">Precio</Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              size="small"
              type="number"
              fullWidth
              value={subarea.price}
              onChange={(e) => _handleSetDataFieldArea(CONST.PRICE, e.target.value)}
              id={CONST.PRICE}
              InputProps={{
                inputProps: { min: 0, readOnly: isManager },
              }}
            />
          </Grid>
        </>
      )} */}
      <Grid item xs={12} md={8}>
        <Typography variant="body">
          A partir de cuantos días previos se puede reservar
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.daysForReserve}
          onChange={(e) =>
            _handleSetDataFieldArea(CONST.DAYS_FOR_RESERVE, e.target.value)
          }
          id={CONST.DAYS_FOR_RESERVE}
          InputProps={{
            inputProps: { min: 0, readOnly: isManager },
          }}
        />
      </Grid>
      {isHourBlock && (
        <>
          <Grid item xs={12} md={8}>
            <Typography variant="body">
              A partir de que hora se puede reservar
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControl variant="standard" sx={{ width: '100%' }}>
              <TextField
                size="small"
                type="time"
                fullWidth
                value={subarea.hoursForReserve}
                inputProps={{ readOnly: isManager }}
                onChange={(e) =>
                  _handleSetDataFieldArea(CONST.HOURS_FOR_RESERVE, e.target.value)
                }
                id={CONST.HOURS_FOR_RESERVE}
              />
            </FormControl>
          </Grid>
        </>
      )}
      <Grid item xs={12} md={8}>
        <Typography variant="body">
          Minutos cercanos a una reserva para que cualquier usuario la pueda
          reservar, sin importar las validaciones
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.minPrevForReserve}
          onChange={(e) =>
            _handleSetDataFieldArea(CONST.MIN_PREV_FOR_RESERVE, e.target.value)
          }
          id={CONST.MIN_PREV_FOR_RESERVE}
          InputProps={{
            inputProps: { min: 0, readOnly: isManager },
          }}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography variant="body">
          Minutos antes de que se pueda eliminar una reserva
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.minutesBeforeRemove}
          onChange={(e) =>
            _handleSetDataFieldArea('minutesBeforeRemove', e.target.value)
          }
          id={'minutesBeforeRemove'}
          InputProps={{
            inputProps: { min: 0, readOnly: isManager },
          }}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography variant="body">Mínimo de personas</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.minPersons}
          onChange={(e) => {
            setSubArea({ ...subarea, minPersons: e.target.value });
          }}
          id={CONST.MIN_PERSONS}
          InputProps={{
            inputProps: { min: 1 },
          }}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography variant="body">Máximo de personas</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          size="small"
          type="number"
          fullWidth
          value={subarea.maxPersons}
          onChange={(e) => {
            setSubArea({ ...subarea, maxPersons: e.target.value });
          }}
          id={CONST.MAX_PERSONS}
          InputProps={{
            inputProps: { min: 1 },
          }}
        />
      </Grid>

      <Grid item xs={12} md={8}>
        <Typography variant="body">Tipo de ingreso de personas</Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth>
          {/* <InputLabel id="select-estatus-label">Tipo de ingreso de personas</InputLabel> */}
          <Select
            labelId="select-estatus-label"
            size="small"
            value={subarea.participantType}
            // label="Tipo de ingreso de personas"
            onChange={(e) => {
              setSubArea({ ...subarea, participantType: e.target.value });
            }}
            id="participantType"
          >
            <MenuItem value="total_only">Solo total</MenuItem>
            <MenuItem value="detailed">Detallado</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} md={12}>
        <FormControl fullWidth>
          <FormControlLabel
            control={
              <Checkbox
                checked={subarea.isAttendantRequired}
                onChange={(e) => {
                  setSubArea({ ...subarea, isAttendantRequired: e.target.checked });
                }}
              />
            }
            label="Asistencia requerida"
          />
        </FormControl>
      </Grid>
    </Grid>
  );

  return (
    <Box component="form" sx={{}}>
      <Grid container>
        <Grid item xs={12} md={12}>
          <LoadingComponent
            isLoading={loadingSave}
            text={subareasStore.activo ? 'Actualizando...' : 'Guardando...'}
          />


          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabs}
              onChange={onTabs}
              aria-label="basic tabs example"
            >
              <Tab label="Información" {...a11yProps(0)} />
              <Tab label="Validaciones" {...a11yProps(1)} />
              <Tab label="Horarios" {...a11yProps(2)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={tabs} index={0}>
            {infoForm}
          </CustomTabPanel>
          <CustomTabPanel value={tabs} index={1}>
            {validacionesForm}
          </CustomTabPanel>
          <CustomTabPanel value={tabs} index={2}>
            {horariosForm}
          </CustomTabPanel>

          {/* <Grid container spacing={2}>
            <Grid item xs={12} md={5}>
              <Typography variant="body" sx={{ fontWeight: 'bold' }}>
                Información
              </Typography>
              <Divider sx={{ mb: 1 }}></Divider>
              {tabPanel1}
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant="body" sx={{ fontWeight: 'bold' }}>
                Validaciones
              </Typography>
              <Divider sx={{ mb: 1 }}></Divider>
              {tabPanel2}
            </Grid>
          </Grid> */}
        </Grid>
        {((subareasStore.activo && action.update) ||
          (!subareasStore.activo && action.create)) && (
          <Grid item md={12} align="center" sx={{ m: 2 }}>
            <BotonNuevoComponent
              click={handleSubmit}
              text="GUARDAR"
              disabled={loadingSave}
              morado
            />
          </Grid>
        )}
      </Grid>
      <Dialog open={openModalChange} onClose={() => setOpenModalChange(false)} fullWidth maxWidth="sm">
        <DialogTitle>Programar cambio</DialogTitle>
        
        <DialogContent>
          {isHourBlock && (
            <Typography variant="body2" color="text.secondary">
              Min: {areasStore.activo.openingTime} - Max: {areasStore.activo.closingTime}
            </Typography>
          )}
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} sx={{ mt: 2 }}>
              <FechaField
                l="Fecha"
                v={changeData.date}
                on={(e) => setChangeData({ ...changeData, date: e })}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <FormSubareaSchedule
                onChange={(e) => {
                  console.log(e);
                  setChangeData({ ...changeData, schedules: e })
                }}
                edit={true}
                data={getScheduleChanges(changeData.schedules)}
                allDay={!isHourBlock}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <BotonNuevoComponent
              click={handleSaveChange}
              text="GUARDAR"
              disabled={loadingSave}
              morado
            />
            <BotonNuevoComponent
              click={() => setOpenModalChange(false)}
              sx={{ ml: 2 }}
              text="CANCELAR"
              disabled={loadingSave}
              blanco
            />
          </Grid>
          {/* <pre>{JSON.stringify(changeData, null, 2)}</pre> */}
        </DialogContent>
      </Dialog>
      <Dialog open={openModalChangeShow} onClose={() => setOpenModalChangeShow(false)} fullWidth maxWidth="sm">
        <DialogTitle>Cambio de horario programado para el día {dayjs(openModalChangeShow?.date).format('DD-MM-YYYY')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <FormSubareaSchedule
                edit={false}
                data={getScheduleChanges(openModalChangeShow?.schedules || [])}
                allDay={!isHourBlock}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
            <BotonNuevoComponent
              click={() => setOpenModalChangeShow(null)}
              sx={{ ml: 2 }}
              text="CANCELAR"
              disabled={loadingSave}
              blanco
            />
            <BotonNuevoComponent
              click={handleLoadExistData}
              sx={{ ml: 2 }}
              text="Eliminar"
              disabled={loadingSave}
              color='red'
            />
          </Grid>
        </DialogContent>
      </Dialog>
      <Modal
          id="modalToggleActivo"
          title="Bloquear subareas"
          open={modalConfirm}
          maxWidth="md"
          onClose={() => setModalConfirm(false)}
        >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Existen reservas, eventos y/o bloqueos en las fechas seleccionadas, ¿desea continuar?
          </DialogContentText>
          <TableContainer component={Paper}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Motivo/Usuario</TableCell>
                  <TableCell align="left" width={200}>Fecha</TableCell>
                  <TableCell align="left">Subárea</TableCell>
                  <TableCell align="left">Tipo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  existData.map((item, index) => {
                    return (
                      <TableRow
                        key={`row_${index}`}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell align="left">
                          {
                            item.name ? (
                              <Typography variant="body1">{item.name} - {item.code}</Typography>
                            ) : (
                              <Typography variant="body1">{item.title}</Typography>
                            )
                          }
                        </TableCell>
                        <TableCell align="left">{item.date}<br/>{item.start} - {item.end}</TableCell>
                        <TableCell align="left">{item.subarea}</TableCell>
                        <TableCell align="left">
                          <Chip label={item.type} style={{ color: '#fff', backgroundColor: item.type === 'Evento' ? '#FF9800' : item.type === 'Bloqueo' ? '#F44336' : '#4CAF50' }} />
                        </TableCell>
                      </TableRow>
                    )
                  })
                }
              </TableBody>
            </Table>
          </TableContainer>
              
        </DialogContent>
        <DialogActions>
          <Button
            color="error"
            variant="outlined"
            onClick={async () => {
              setModalConfirm(false);
              await handleDeleteChange();
            }}
          >
            ACEPTAR
          </Button>
          <Button
            sx={{ color: MORADO_COLOR }}
            onClick={() => setModalConfirm(false)}
          >
            CANCELAR
          </Button>
        </DialogActions>
      </Modal>
      {
        confirmDelete && (
          <Modal
            id="modalDeleteReserva"
            title={`Eliminar horario programado`}
            open={confirmDelete}
            maxWidth="sm"
            onClose={() => {
              setConfirmDelete(false)
            }}
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                ¿Seguro que quieres eliminar este horario programado?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                color="error"
                variant="outlined"
                onClick={handleLoadExistData}
              >
                ELIMINAR
              </Button>
              <Button onClick={() => setConfirmDelete(false)}>CANCELAR</Button>
            </DialogActions>
          </Modal>
        )
      }
    </Box>
  );
};

FormSubAreas.propTypes = {
  getAll: PropTypes.func,
  setOpenModalForm: PropTypes.func,
};

export default FormSubAreas;
